import { IconProps } from '../icons';
import { themeColors } from '@styles/theme';

export const MergeSelectionSetsIcon = ({
    width = 24,
    height = 24,
    color = themeColors.grey,
}: IconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect x="3.5" y="4.5" width="8" height="8" rx="1.5" stroke={color} strokeWidth="1.5" />
            <rect
                x="12.5"
                y="4.5"
                width="8"
                height="8"
                rx="1.5"
                stroke={color}
                strokeWidth="1.5"
            />
            <path
                d="M7.5 15V18.5C7.5 19.6 8.4 20.5 9.5 20.5H14.5C15.6 20.5 16.5 19.6 16.5 18.5V15"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
};
